import Select from "../../../common/select";
import Checkbox from "../../../common/checkbox";
import React, { useEffect, useState } from "react";
import Notification from "../../../common/notification";
import SwitchButton from "../../../common/switch-button";
import PumpPerformanceChart from "../../../line-graphs";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import EquipmentTableAddChargePump from "../../../common/equipment-table-charge-pump";
import { useGasCalculationFacade } from "../../../../facade/calculation/calculation-output/gasCalculation.facade";
import { typeOfShaft } from "../../../../constants/dropdown/calculations";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { useGasHandlerFacade } from "../../../../facade/calculation/calculation-output/gas-handler.facade";
import { LABELS } from "../../../../constants/labels/gasCals.labels";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
import TextShortInput from "../../../common/TextShortInput";
import Dropdown from "../../../common/dropdown";
import { usePumpFacade } from "../../../../facade/calculation/calculation-output/pump.facade";

const AddChargePump = () => {
    const [isShowGraph1, setIsShowGraph1] = useState<boolean>(false);
    const [isShowGraph2, setIsShowGraph2] = useState<boolean>(false);
    const [isShowGraph3, setIsShowGraph3] = useState<boolean>(false);

    const [notification, setNotification] = useState({
        type: "",
        message: "",
        show: false,
    });

    const {
        updateCP1CalculationData,
        updateCP2CalculationData,
        updateCP3CalculationData,
    } = useGasHandlerFacade();

    const {
        existedSRGasPump3Equipments,
        existedSRGasPump2Equipments,
        existedSRGasPump1Equipments,
        GasCalculationOutPut,
        showSRGasPump1Equipments,
        showSRGasPump2Equipments,
        showSRGasPump3Equipments,
    } = useAppSelector((state) => state?.gasCalculations);

    const { CP1CalculationData, CP2CalculationData, CP3CalculationData } = useAppSelector((state) => state?.gasHandler);
    const {
        updateUseChargePump,
        updateSelectedChargePump1,
        updateSelectedChargePump2,
        updateSelectedChargePump3,
        updateSelectedTypeOfShaft1,
        updateSelectedTypeOfShaft2,
        updateSelectedTypeOfShaft3,
        updateDesiredNoOfStages1,
        updateDesiredNoOfStages2,
        updateDesiredNoOfStages3,
        updateChargePumpName,
        updateChargePump2Name,
        updateChargePump3Name,
        existedChargePump1Equipments,
        existedChargePump2Equipments,
        existedChargePump3Equipments,
        SetChargePumpDesrdStge,
        SetChargePumpDesrdStge2,
        SetChargePumpDesrdStge3,
        loadChargePump1EquipmentList,
        loadChargePump2EquipmentList,
        loadChargePump3EquipmentList,
        updateGasCalculationOutput,
        updateShowHidePump1Equipments,
        updateShowHidePump2Equipments,
        updateShowHidePump3Equipments,
        SetChargePump,
        SetChargePump2,
        SetChargePump3
    } = useGasCalculationFacade();
    const { updateChargePumpShowAll } = useTubingFacade();
    const { updateSchematicEquipmentData } = useCalculationFacade();
    const { updatePumpDesrdStges } = usePumpFacade();

    const {
        BasicGasCalculation,
        CP1GraphCurveData,
        CP2GraphCurveData,
        CP3GraphCurveData,
    } = useAppSelector((state) => state?.gasCalculations);

    const { tab1Input } = useAppSelector((state) => state?.tubing);
    const { ESPEquipments } = useAppSelector((state) => state?.pump);

    const [desiredNoOfStgs, setDesiredNoOfStgs] = useState<{ CP1: string, CP2: string, CP3: string }>({
        CP1: BasicGasCalculation?.chargePumpDesrdStge?.toString() ?? "",
        CP2: BasicGasCalculation?.chargePumpDesrdStge2?.toString() ?? "",
        CP3: BasicGasCalculation?.chargePumpDesrdStge3?.toString() ?? ""
    });

    useEffect(() => {
        if (BasicGasCalculation && Object?.keys(BasicGasCalculation)?.length > 0) {
            setDesiredNoOfStgs((prev) => ({
                CP1: BasicGasCalculation?.chargePumpDesrdStge?.toString(),
                CP2: BasicGasCalculation?.chargePumpDesrdStge2?.toString(),
                CP3: BasicGasCalculation?.chargePumpDesrdStge3?.toString()
            }));
        }
    }, [BasicGasCalculation]);

    useEffect(() => {
        const chargePumps = [
            ...existedSRGasPump3Equipments,
            ...existedSRGasPump2Equipments,
            ...existedSRGasPump1Equipments,
        ];
        const countWithValues = chargePumps.filter((pump) => pump).length;

        let limit = 7;
        if (countWithValues === 3) limit = 4;
        else if (countWithValues === 2) limit = 5;
        else if (countWithValues === 1) limit = 6;


        let updatedEquipments = [...ESPEquipments];
        if (updatedEquipments.length > limit) {
            updatedEquipments = updatedEquipments
                .slice(0, limit)
                .filter((item) => Object.keys(item).length > 0);
            while (updatedEquipments.length < limit) {
                updatedEquipments.push({});
            }
        }

        const totalStgs = updatedEquipments.reduce((sum, equipment) => sum + (equipment.noStgs || 0), 0);
        totalStgs > 0 && updatePumpDesrdStges(totalStgs);

    }, [existedSRGasPump3Equipments, existedSRGasPump2Equipments, existedSRGasPump1Equipments])

    const handleSelectChange = (option: any) => {
        updateUseChargePump(option?.id);
        if (option?.id === "0") {
            updateSelectedTypeOfShaft1(0);
            updateSelectedTypeOfShaft2(0);
            updateSelectedTypeOfShaft3(0);
            setIsShowGraph1(false);
            setIsShowGraph2(false);
            setIsShowGraph3(false);
            SetChargePump("");
            existedChargePump1Equipments([]);
            existedChargePump2Equipments([]);
            existedChargePump3Equipments([]);
            updateShowHidePump1Equipments(false);
            updateShowHidePump2Equipments(false);
            updateShowHidePump3Equipments(false);
            const GasCalculationOutPut = {
                CP1_HPRating: 0,
                CP2_HPRating: 0,
                CP3_HPRating: 0
            };
            updateGasCalculationOutput(GasCalculationOutPut);
            updateSchematicEquipmentData();
        }
    };

    const onSelectChangeChargePump1 = (option: any) => {
        const gasOutput = {
            CP1_FlowCorrection: BasicGasCalculation?.cP1FlowCorrection ?? 100,
            CP1_HeadCorrection: BasicGasCalculation?.cP1HeadCorrection ?? 100,
            CP1_PowerCorrection: BasicGasCalculation?.cP1PowerCorrection ?? 100
        }
        updateGasCalculationOutput(gasOutput);
        updateSelectedChargePump1(option?.value);
        updateChargePumpName(option?.label);
        existedChargePump1Equipments([]);
        updateDesiredNoOfStages1("");
        loadChargePump1EquipmentList();
        updateSelectedTypeOfShaft1(0);
        updateShowHidePump1Equipments(false);
        SetChargePump(option?.value);
        if (option?.label === "Select") {
            setIsShowGraph1(false);
            setIsShowGraph2(false);
            setIsShowGraph3(false);
            updateShowHidePump1Equipments(false);
            SetChargePump("");
            const GasCalculationOutPut = {
                CP1_HPRating: 0,
                CP2_HPRating: 0,
                CP3_HPRating: 0
            };
            updateGasCalculationOutput(GasCalculationOutPut);
            updateShowHidePump1Equipments(false);
            existedChargePump1Equipments([]);
            updateShowHidePump2Equipments(false);
            existedChargePump2Equipments([]);
            updateShowHidePump3Equipments(false);
            existedChargePump3Equipments([]);
            updateSchematicEquipmentData();
        };
    };

    const [chargePumpFlag1, setChargePumpFlag1] = useState<boolean>(false);

    const onChangeDesiredNoOfStages = (e: any) => {
        const { value } = e.target;
        const regex = /^[0-9]+(\.[0-9]*)?$/;
        if (regex.test(value) || value === "") {
            setChargePumpFlag1(true);
            setDesiredNoOfStgs((prev) => ({ ...prev, CP1: value }));
        } else setChargePumpFlag1(false);
    };

    const onBlurDesiredNoOfStages = async (e: any) => {
        if (chargePumpFlag1) {
            updateDesiredNoOfStages1(Number(desiredNoOfStgs?.CP1));
            SetChargePumpDesrdStge(desiredNoOfStgs?.CP1);
        } else {
            updateDesiredNoOfStages1("");
        }
        if (existedSRGasPump1Equipments && Object?.keys(existedSRGasPump1Equipments)?.length > 0 &&
            Number(desiredNoOfStgs?.CP1) !== existedSRGasPump1Equipments[0].noStgs && existedSRGasPump1Equipments[0].noStgs !== undefined
        ) {
            existedChargePump1Equipments([{}]);
            setNotification((prev) => ({
                ...prev,
                type: "warning",
                message:
                    "Pump correlations are cleared due to manual override on Desired No. Of Stages.",
                show: true,
            }));
            updateSchematicEquipmentData();
            if (BasicGasCalculation?.hdn_ChargePump1_ShaftType === 1) {
                updateSelectedTypeOfShaft1(0);
            }
        }
        if (desiredNoOfStgs?.CP1 === "") setIsShowGraph1(false);
    };

    const handleChangeChargePump1 = async (option: any) => {
        setDesiredNoOfStgs((prev) => ({ ...prev, CP1: option?.noStgs }));
        updateDesiredNoOfStages1(option?.noStgs);
        SetChargePumpDesrdStge(option?.noStgs);
        existedChargePump1Equipments([option]);
        updateSchematicEquipmentData();
    };

    const handleOnClear1 = () => {
        existedChargePump1Equipments([]);
        updateDesiredNoOfStages1("");
        SetChargePumpDesrdStge("");
        updateSchematicEquipmentData();
    };

    const onSelectChangeTypeOfShaft1 = async (option: any) => {
        updateSelectedTypeOfShaft1(option?.value);
    };

    const onSelectChangeChargePump2 = (option: any) => {
        const gasOutput = {
            CP2_FlowCorrection: BasicGasCalculation?.cP2FlowCorrection ?? 100,
            CP2_HeadCorrection: BasicGasCalculation?.cP2HeadCorrection ?? 100,
            CP2_PowerCorrection: BasicGasCalculation?.cP2PowerCorrection ?? 100
        }
        updateGasCalculationOutput(gasOutput);
        updateSelectedChargePump2(option?.value);
        SetChargePump2(option?.value);
        existedChargePump2Equipments([]);
        updateShowHidePump2Equipments(false);
        updateDesiredNoOfStages2("");
        updateChargePump2Name(option?.label);
        updateSelectedTypeOfShaft2(0);
        loadChargePump2EquipmentList();
        if (option.value === "") {
            updateSelectedChargePump3("");
            setIsShowGraph2(false);
            setIsShowGraph3(false);
            updateDesiredNoOfStages2("");
            updateDesiredNoOfStages3("");
        };
        if (option?.label === "Select") {
            SetChargePump2("");
            setIsShowGraph2(false);
            setIsShowGraph3(false);
            updateChargePump2Name("");
            updateChargePump3Name("");
            updateDesiredNoOfStages2("");
            updateCP2CalculationData(null);
            updateCP3CalculationData(null);
            const GasCalculationOutPut = {
                CP2_HPRating: 0,
                CP3_HPRating: 0
            };
            updateGasCalculationOutput(GasCalculationOutPut);
            updateShowHidePump2Equipments(false);
            updateSelectedChargePump2("");
            updateSelectedChargePump3("");
            updateDesiredNoOfStages3("");
            updateSelectedTypeOfShaft2(0);
            existedChargePump2Equipments([]);
            existedChargePump3Equipments([]);
            updateSchematicEquipmentData();
        };
    };

    const onSelectChangeChargePump3 = (option: any) => {
        const gasOutput = {
            CP3_FlowCorrection: BasicGasCalculation?.cP3FlowCorrection ?? 100,
            CP3_HeadCorrection: BasicGasCalculation?.cP3HeadCorrection ?? 100,
            CP3_PowerCorrection: BasicGasCalculation?.cP3PowerCorrection ?? 100
        }
        updateGasCalculationOutput(gasOutput);
        updateSelectedChargePump3(option?.value);
        SetChargePump3(option?.value);
        existedChargePump3Equipments([]);
        updateShowHidePump3Equipments(false);
        updateDesiredNoOfStages3("");
        updateSelectedTypeOfShaft3(0);
        updateChargePump3Name(option?.label);
        loadChargePump3EquipmentList();
        if (option.value === "") {
            setIsShowGraph3(false);
            updateDesiredNoOfStages3("");
        };
        if (option?.label === "Select") {
            SetChargePump3("");
            setIsShowGraph3(false);
            updateChargePump3Name("");
            updateDesiredNoOfStages3("");
            updateShowHidePump3Equipments(false);
            updateCP3CalculationData(null);
            const GasCalculationOutPut = {
                CP3_HPRating: 0
            };
            updateGasCalculationOutput(GasCalculationOutPut);
            updateCP3CalculationData(null);
            updateSelectedTypeOfShaft3(0);
            existedChargePump3Equipments([]);
            updateSchematicEquipmentData();
        };
    };

    const handleOnClear2 = () => {
        existedChargePump2Equipments([]);
        updateDesiredNoOfStages2("");
        SetChargePumpDesrdStge2("");
        updateSchematicEquipmentData();
    };
    const handleOnClear3 = () => {
        existedChargePump3Equipments([]);
        updateDesiredNoOfStages3("");
        SetChargePumpDesrdStge3("");
        updateSchematicEquipmentData();
    };

    const onChangeDesiredNoOfStages2 = (e: any) => {
        const { value } = e.target;
        const regex = /^[0-9]+(\.[0-9]*)?$/;
        if (regex.test(value) || value === "") {
            setDesiredNoOfStgs((prev) => ({ ...prev, CP2: value }));
        } else setDesiredNoOfStgs((prev) => ({ ...prev, CP2: value }));
    };

    const onBlurDesiredNoOfStages2 = async (e: any) => {
        updateDesiredNoOfStages2(desiredNoOfStgs?.CP2);
        SetChargePumpDesrdStge2(desiredNoOfStgs?.CP2);
        if (existedSRGasPump2Equipments && Object?.keys(existedSRGasPump2Equipments)?.length > 0 &&
            Number(desiredNoOfStgs?.CP2) !== existedSRGasPump2Equipments[0]?.noStgs && existedSRGasPump2Equipments[0]?.noStgs !== undefined
        ) {
            setNotification((prev) => ({
                ...prev,
                type: "warning",
                message:
                    "Pump correlations are cleared due to manual override on Desired No. Of Stages.",
                show: true,
            }));
            existedChargePump2Equipments([{}]);
            updateSchematicEquipmentData();
            if (BasicGasCalculation?.hdn_ChargePump2_ShaftType === 1) {
                updateSelectedTypeOfShaft2(0);
            }
        }
        if (desiredNoOfStgs?.CP2 === "") setIsShowGraph2(false);
    };

    const handleChangeChargePump2 = (option: any) => {
        setDesiredNoOfStgs((prev) => ({ ...prev, CP2: option?.noStgs }));
        updateDesiredNoOfStages2(option?.noStgs);
        SetChargePumpDesrdStge2(option?.noStgs);
        existedChargePump2Equipments([option]);
        updateSchematicEquipmentData();
    };

    const onChangeDesiredNoOfStages3 = (e: any) => {
        const { value } = e.target;
        const regex = /^[0-9]+(\.[0-9]*)?$/;
        if (regex.test(value) || value === "") {
            setDesiredNoOfStgs((prev) => ({ ...prev, CP3: value }));
        } else setDesiredNoOfStgs((prev) => ({ ...prev, CP3: "" }));
    };

    const onBlurDesiredNoOfStages3 = async (e: any) => {
        updateDesiredNoOfStages3(desiredNoOfStgs?.CP3);
        SetChargePumpDesrdStge3(desiredNoOfStgs?.CP3);
        if (existedSRGasPump3Equipments && Object?.keys(existedSRGasPump3Equipments)?.length > 0 &&
            Number(desiredNoOfStgs?.CP3) !== existedSRGasPump3Equipments?.[0]?.noStgs && existedSRGasPump3Equipments?.[0]?.noStgs !== undefined
        ) {
            setNotification((prev) => ({
                ...prev,
                type: "warning",
                message:
                    "Pump correlations are cleared due to manual override on Desired No. Of Stages.",
                show: true,
            }));
            existedChargePump3Equipments([{}]);
            updateSchematicEquipmentData();
            if (BasicGasCalculation?.hdn_ChargePump3_ShaftType === 1) {
                updateSelectedTypeOfShaft3(0);
            }
        }
        if (desiredNoOfStgs?.CP3 === "") {
            setIsShowGraph3(false);
            existedChargePump3Equipments([{}]);
        }
    };

    const handleChangeChargePump3 = (option: any) => {
        updateDesiredNoOfStages3(option?.noStgs);
        SetChargePumpDesrdStge3(option?.noStgs);
        existedChargePump3Equipments([option]);
        updateSchematicEquipmentData();
    };

    const onSelectChangeTypeOfShaft2 = (option: any) => {
        updateSelectedTypeOfShaft2(option?.value);
    };

    const onSelectChangeTypeOfShaft3 = (option: any) => {
        updateSelectedTypeOfShaft3(option?.value);
    };

    const handleShowGraph1 = () => {
        setIsShowGraph1(!isShowGraph1);
    };

    const handleShowGraph2 = () => {
        setIsShowGraph2(!isShowGraph2);
    };

    const handleShowGraph3 = () => {
        setIsShowGraph3(!isShowGraph3);
    };

    const {
        addChargePumpCollapse,
        chargePump1Collapse,
        chargePump2Collapse,
        chargePump3Collapse,
    } = useAppSelector((state) => state?.collapse);

    const {
        updateAddChargePumpCollapse,
        updateChargePump1Collapse,
        updateChargePump2Collapse,
        updateChargePump3Collapse,
    } = useCollapseFacade();

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "addChargePump") updateAddChargePumpCollapse(key);
        else if (name === "chargePump1") updateChargePump1Collapse(key);
        else if (name === "chargePump2") updateChargePump2Collapse(key);
        else if (name === "chargePump3") updateChargePump3Collapse(key);
    };

    const handleShowAllPumps = (e: React.ChangeEvent<HTMLInputElement>) => {
        const data = e?.target?.checked;
        updateChargePumpShowAll(data);
    };

    return (
        <>
            <Accordion
                title={LABELS?.addChargePump}
                tooltipText={LABELS?.formula}
                link={"/help?tab=Gas-Calculations#wapperChargePump"}
                isOpen={addChargePumpCollapse}
                onToggle={() =>
                    handleCollapseChange(!addChargePumpCollapse, "addChargePump")
                }
                content={
                    <div className="flex flex-col self-stretch gap-[16px] p-[16px] rounded-b-[8px]">
                        <div className="flex items-end gap-[16px] w-full">
                            <div className="flex w-[50%]">
                                <Dropdown
                                    label={LABELS?.useOfChargePump}
                                    options={[
                                        { id: "0", name: LABELS?.no },
                                        { id: "1", name: LABELS?.yes },
                                    ]}
                                    onSelect={(option) => handleSelectChange(option)}
                                    dropdownBgColor="bg-darkcolor-800"
                                    bgColor="bg-transparent"
                                    selected={BasicGasCalculation?.useOfChgPmpNew ?? "0"}
                                    width="1/2"
                                    height="80px"
                                />
                            </div>
                            <div className="flex w-[50%]">
                                <Checkbox
                                    label={LABELS?.showAllPumps}
                                    checked={tab1Input?.chargePumpShowAll}
                                    name="showAllPumps"
                                    onChange={(e) => handleShowAllPumps(e)}
                                />
                            </div>
                        </div>
                        {BasicGasCalculation?.useOfChgPmpNew === "1" && (
                            <>
                                <Accordion
                                    title={LABELS?.chargePump1}
                                    isOpen={chargePump1Collapse}
                                    onToggle={() =>
                                        handleCollapseChange(!chargePump1Collapse, "chargePump1")
                                    }
                                    content={
                                        <div className="flex flex-col self-stretch gap-[16px] p-[16px] bg-darkcolor-700 rounded-b-[8px]">
                                            <div className="grid sm:grid-cols-2 grid-cols-1 gap-[16px]">
                                                <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                                    <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                                        <p className="text-white">{LABELS?.chargePump}</p>
                                                        <Select
                                                            options={BasicGasCalculation?.chargePumpList}
                                                            onChange={onSelectChangeChargePump1}
                                                            padding="px-[14px] py-[5px]"
                                                            fontSize="16px"
                                                            className="sm:px-0 px-[10px] w-[224px]"
                                                            selectedValue={BasicGasCalculation?.chargePump}
                                                            name={"chargePump"}
                                                        />
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400">
                                                        <p className="text-white">
                                                            {LABELS?.desirednoOfStages}
                                                        </p>
                                                        <TextShortInput
                                                            className="px-[10px] py-[5px] w-[224px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                                                            name="chargePumpDesrdStge"
                                                            onChange={onChangeDesiredNoOfStages}
                                                            value={desiredNoOfStgs?.CP1}
                                                            onBlur={onBlurDesiredNoOfStages}
                                                        />
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                                        <p className="text-white">{LABELS?.typeOfShaft}</p>
                                                        <Select
                                                            options={typeOfShaft}
                                                            onChange={onSelectChangeTypeOfShaft1}
                                                            padding="px-[14px] py-[5px]"
                                                            fontSize="16px"
                                                            className="sm:px-0 px-[10px] w-[224px]"
                                                            selectedValue={
                                                                BasicGasCalculation?.hdn_ChargePump1_ShaftType ??
                                                                0
                                                            }
                                                            name={"chargePump"}
                                                        />
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                        <p className="text-white">
                                                            {LABELS?.targetFlowRate}
                                                        </p>
                                                        <p className="text-white">
                                                            {CP1CalculationData?.targetFlowRate} {LABELS?.bpd}
                                                        </p>
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[14px]">
                                                        <p className="text-white">{LABELS?.liftStage}</p>
                                                        <p className="text-white">
                                                            {CP1CalculationData?.liftPerStage} {LABELS?.ft}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                        <p className="text-white">{LABELS?.tdh}</p>
                                                        <p className="text-white">
                                                            {CP1CalculationData?.finalTDH} {LABELS?.ft}
                                                        </p>
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                        <p className="text-white">
                                                            {LABELS?.totalbhpChargePump1}
                                                        </p>
                                                        <p className="text-white">
                                                            {CP1CalculationData?.totalPower} {LABELS?.hp}
                                                        </p>
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                        <p className="text-white">
                                                            {LABELS?.bhpChargePump1}
                                                        </p>
                                                        <p className="text-white">
                                                            {GasCalculationOutPut?.CP1_HPRating ?? 0} {LABELS?.hp}
                                                        </p>
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                        <p className="text-white">{LABELS?.efficiency}</p>
                                                        <p className="text-white">
                                                            {CP1CalculationData?.efficiency} %
                                                        </p>
                                                    </div>
                                                    <div className="flex justify-between items-center px-[24px] py-[14px]">
                                                        <p className="text-white">{LABELS?.shaftLoad}</p>
                                                        <p className="text-white">
                                                            {CP1CalculationData?.shaftLoad} %
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {showSRGasPump1Equipments && (
                                                <EquipmentTableAddChargePump
                                                    options={
                                                        BasicGasCalculation?.EquipmentListForChargePumpOne
                                                            ?.length > 0
                                                            ? BasicGasCalculation?.EquipmentListForChargePumpOne
                                                            : []
                                                    }
                                                    onChange={handleChangeChargePump1}
                                                    equipments={existedSRGasPump1Equipments?.length > 0
                                                        ? existedSRGasPump1Equipments
                                                        : [{}]}
                                                    onClear={handleOnClear1}
                                                    rowLength={1}
                                                    equipmentGridParentContainer="SRChargePump1"
                                                    parentId={BasicGasCalculation?.chargePump}
                                                    styles={{ width: "170px", wordWrap: "break-word" }}
                                                />
                                            )}
                                            <div className="mb-[5px]">
                                                <SwitchButton
                                                    checked={isShowGraph1}
                                                    onChange={handleShowGraph1}
                                                    label={LABELS?.showChargePump1Graph}
                                                    disabled={BasicGasCalculation?.chargePumpDesrdStge === ""}
                                                />
                                            </div>
                                            {isShowGraph1 && BasicGasCalculation?.chargePump && (
                                                <div className="mb-[15px]">
                                                    <PumpPerformanceChart data={CP1GraphCurveData} />
                                                </div>
                                            )}
                                        </div>
                                    }
                                />
                                {BasicGasCalculation?.chargePump && (
                                    <>
                                        <Accordion
                                            title={LABELS?.chargePump2}
                                            isOpen={chargePump2Collapse}
                                            onToggle={() =>
                                                handleCollapseChange(
                                                    !chargePump2Collapse,
                                                    "chargePump2"
                                                )
                                            }
                                            content={
                                                <div className="flex flex-col self-stretch gap-[16px] p-[16px] bg-darkcolor-700 rounded-b-[8px]">
                                                    <div className="grid sm:grid-cols-2 grid-cols-1 gap-[16px]">
                                                        <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                                            <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                                                <p className="text-white">{LABELS?.chargePump}</p>
                                                                <Select
                                                                    options={BasicGasCalculation?.chargePumpList2}
                                                                    onChange={onSelectChangeChargePump2}
                                                                    padding="px-[14px] py-[5px]"
                                                                    fontSize="16px"
                                                                    className="sm:px-0 px-[10px] w-[224px]"
                                                                    selectedValue={
                                                                        BasicGasCalculation?.chargePump2
                                                                    }
                                                                    name={"chargePump"}
                                                                />
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400">
                                                                <p className="text-white">
                                                                    {LABELS?.desirednoOfStages}
                                                                </p>
                                                                <TextShortInput
                                                                    className="px-[10px] py-[5px] w-[224px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                                                                    name="chargePumpDesrdStge"
                                                                    value={
                                                                        desiredNoOfStgs?.CP2
                                                                    }
                                                                    onChange={onChangeDesiredNoOfStages2}
                                                                    onBlur={onBlurDesiredNoOfStages2}
                                                                />
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                                                <p className="text-white">
                                                                    {LABELS?.typeOfShaft}
                                                                </p>
                                                                <Select
                                                                    options={typeOfShaft}
                                                                    onChange={onSelectChangeTypeOfShaft2}
                                                                    padding="px-[14px] py-[5px]"
                                                                    fontSize="16px"
                                                                    className="sm:px-0 px-[10px] w-[224px]"
                                                                    selectedValue={
                                                                        BasicGasCalculation?.hdn_ChargePump2_ShaftType ??
                                                                        0
                                                                    }
                                                                    name={"chargePump"}
                                                                />
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                <p className="text-white">
                                                                    {LABELS?.targetFlowRate}
                                                                </p>
                                                                <p className="text-white">
                                                                    {CP2CalculationData?.targetFlowRate} {LABELS?.bpd}
                                                                </p>
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[14px]">
                                                                <p className="text-white">
                                                                    {LABELS?.liftStage}
                                                                </p>
                                                                <p className="text-white">
                                                                    {CP2CalculationData?.liftPerStage} {LABELS?.ft}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                                            <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                <p className="text-white">{LABELS?.tdh}</p>
                                                                <p className="text-white">
                                                                    {CP2CalculationData?.finalTDH} {LABELS?.ft}
                                                                </p>
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                <p className="text-white">
                                                                    {LABELS?.totalbhpChargePump2}
                                                                </p>
                                                                <p className="text-white">
                                                                    {CP2CalculationData?.totalPower} {LABELS?.hp}
                                                                </p>
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                <p className="text-white">
                                                                    {LABELS?.bhpChargePump2}
                                                                </p>
                                                                <p className="text-white">
                                                                    {GasCalculationOutPut?.CP2_HPRating ?? 0} {LABELS?.hp}
                                                                </p>
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                <p className="text-white">{LABELS?.efficiency}</p>
                                                                <p className="text-white">
                                                                    {CP2CalculationData?.efficiency} %
                                                                </p>
                                                            </div>
                                                            <div className="flex justify-between items-center px-[24px] py-[14px]">
                                                                <p className="text-white">{LABELS?.shaftLoad}</p>
                                                                <p className="text-white">
                                                                    {CP2CalculationData?.shaftLoad} %
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {showSRGasPump2Equipments && (
                                                        <EquipmentTableAddChargePump
                                                            options={
                                                                BasicGasCalculation
                                                                    ?.EquipmentListForChargePumpTwo?.length > 0
                                                                    ? BasicGasCalculation?.EquipmentListForChargePumpTwo
                                                                    : []
                                                            }
                                                            onChange={handleChangeChargePump2}
                                                            equipments={existedSRGasPump2Equipments?.length > 0 ? existedSRGasPump2Equipments : [{}]}
                                                            onClear={handleOnClear2}
                                                            rowLength={1}
                                                            equipmentGridParentContainer="SRChargePump2"
                                                            parentId={BasicGasCalculation?.chargePump2}
                                                            styles={{ width: "170px", wordWrap: "break-word" }}
                                                        />
                                                    )}
                                                    <div className="mb-[5px]">
                                                        <SwitchButton
                                                            checked={isShowGraph2}
                                                            onChange={handleShowGraph2}
                                                            label={LABELS?.showChargePump2Graph}
                                                            disabled={BasicGasCalculation?.chargePumpDesrdStge2 === ""}
                                                        />
                                                    </div>
                                                    {isShowGraph2 && BasicGasCalculation?.chargePump2 && (
                                                        <div className="mb-[15px]">
                                                            <PumpPerformanceChart data={CP2GraphCurveData} />
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                        />

                                        {BasicGasCalculation?.chargePump2 && (
                                            <Accordion
                                                title={LABELS?.chargePump3}
                                                isOpen={chargePump3Collapse}
                                                onToggle={() =>
                                                    handleCollapseChange(
                                                        !chargePump3Collapse,
                                                        "chargePump3"
                                                    )
                                                }
                                                content={
                                                    <div className="flex flex-col self-stretch gap-[16px] p-[16px] bg-darkcolor-700 rounded-b-[8px]">
                                                        <div className="grid sm:grid-cols-2 grid-cols-1 gap-[16px]">
                                                            <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                                                <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                                                    <p className="text-white">
                                                                        {LABELS?.chargePump}
                                                                    </p>
                                                                    <Select
                                                                        options={
                                                                            BasicGasCalculation?.chargePumpList3
                                                                        }
                                                                        onChange={onSelectChangeChargePump3}
                                                                        padding="px-[14px] py-[5px]"
                                                                        fontSize="16px"
                                                                        className="sm:px-0 px-[10px] w-[224px]"
                                                                        selectedValue={
                                                                            BasicGasCalculation?.chargePump3
                                                                        }
                                                                        name={"chargePump"}
                                                                    />
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400">
                                                                    <p className="text-white">
                                                                        {LABELS?.desirednoOfStages}
                                                                    </p>
                                                                    <TextShortInput
                                                                        className="px-[10px] py-[5px] w-[224px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                                                                        name="chargePumpDesrdStge3"
                                                                        value={
                                                                            desiredNoOfStgs?.CP3
                                                                        }
                                                                        onChange={onChangeDesiredNoOfStages3}
                                                                        onBlur={onBlurDesiredNoOfStages3}
                                                                    />
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400 w-full">
                                                                    <p className="text-white">
                                                                        {LABELS?.typeOfShaft}
                                                                    </p>
                                                                    <Select
                                                                        options={typeOfShaft}
                                                                        onChange={onSelectChangeTypeOfShaft3}
                                                                        padding="px-[14px] py-[5px]"
                                                                        fontSize="16px"
                                                                        className="sm:px-0 px-[10px] w-[224px]"
                                                                        selectedValue={
                                                                            BasicGasCalculation?.hdn_ChargePump3_ShaftType ??
                                                                            0
                                                                        }
                                                                        name={"chargePump"}
                                                                    />
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                    <p className="text-white">
                                                                        {LABELS?.targetFlowRate}
                                                                    </p>
                                                                    <p className="text-white">
                                                                        {CP3CalculationData?.targetFlowRate} {LABELS?.bpd}
                                                                    </p>
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[14px]">
                                                                    <p className="text-white">
                                                                        {LABELS?.liftStage}
                                                                    </p>
                                                                    <p className="text-white">
                                                                        {CP3CalculationData?.liftPerStage} {LABELS?.ft}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                    <p className="text-white">{LABELS?.tdh}</p>
                                                                    <p className="text-white">
                                                                        {CP3CalculationData?.finalTDH} {LABELS?.ft}
                                                                    </p>
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                    <p className="text-white">
                                                                        {LABELS?.totalbhpChargePump3}
                                                                    </p>
                                                                    <p className="text-white">
                                                                        {CP3CalculationData?.totalPower} {LABELS?.hp}
                                                                    </p>
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                    <p className="text-white">
                                                                        {LABELS?.bhpChargePump3}
                                                                    </p>
                                                                    <p className="text-white">
                                                                        {GasCalculationOutPut?.CP3_HPRating ?? 0} {LABELS?.hp}
                                                                    </p>
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                                                    <p className="text-white">
                                                                        {LABELS?.efficiency}
                                                                    </p>
                                                                    <p className="text-white">
                                                                        {CP3CalculationData?.efficiency} %
                                                                    </p>
                                                                </div>
                                                                <div className="flex justify-between items-center px-[24px] py-[14px]">
                                                                    <p className="text-white">
                                                                        {LABELS?.shaftLoad}
                                                                    </p>
                                                                    <p className="text-white">
                                                                        {CP3CalculationData?.shaftLoad} %
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {showSRGasPump3Equipments && (
                                                            <EquipmentTableAddChargePump
                                                                options={
                                                                    BasicGasCalculation
                                                                        ?.EquipmentListForChargePumpThree?.length > 0
                                                                        ? BasicGasCalculation?.EquipmentListForChargePumpThree
                                                                        : []
                                                                }
                                                                onChange={handleChangeChargePump3}
                                                                equipments={existedSRGasPump3Equipments?.length > 0 ? existedSRGasPump3Equipments : [{}]}
                                                                onClear={handleOnClear3}
                                                                rowLength={1}
                                                                equipmentGridParentContainer="SRChargePump3"
                                                                parentId={BasicGasCalculation?.chargePump3}
                                                                styles={{ width: "170px", wordWrap: "break-word" }}
                                                            />
                                                        )}
                                                        <div className="mb-[5px]">
                                                            <SwitchButton
                                                                checked={isShowGraph3}
                                                                onChange={handleShowGraph3}
                                                                label={LABELS?.showChargePump3Graph}
                                                                disabled={BasicGasCalculation?.chargePumpDesrdStge3 === ""}
                                                            />
                                                        </div>
                                                        {isShowGraph3 &&
                                                            BasicGasCalculation?.chargePump3 && (
                                                                <div className="mb-[15px]">
                                                                    <PumpPerformanceChart
                                                                        data={CP3GraphCurveData}
                                                                    />
                                                                </div>
                                                            )}
                                                    </div>
                                                }
                                            />
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </div>
                }
            />
            <div className="fixed top-4 right-4 z-[1005] flex flex-col space-y-4">
                <Notification
                    isOpen={notification?.show}
                    type={notification.type}
                    message={notification.message}
                    onClose={() => setNotification((prev) => ({ ...prev, show: false }))}
                    timeout={1000}
                    width="full"
                />
            </div>
        </>
    );
};

export default AddChargePump;
